module.exports = __webpack_public_path__ + "static/media/warehouse-front.d605e2a7.jpeg";